import AOS from "aos";

document.addEventListener("DOMContentLoaded", () => {
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(
        document.querySelectorAll(".navbar-burger"),
        0
    );

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach((el) => {
            el.addEventListener("click", () => {
                // Get the target from the "data-target" attribute
                const target = el.dataset.target;
                const $target = document.getElementById(target);

                // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
                el.classList.toggle("is-active");
                $target.classList.toggle("is-active");
            });
        });
    }

    (document.querySelectorAll(".notification .delete") || []).forEach(
        ($delete) => {
            let $notification = $delete.parentNode;

            $delete.addEventListener("click", () => {
                $notification.parentNode.removeChild($notification);
            });
        }
    );
});

function throttle(callback, limit) {
    let tick = false;
    return function () {
        if (!tick) {
            callback.call();
            tick = true;
            setTimeout(function () {
                tick = false;
            }, limit);
        }
    };
}

$(document).ready(function () {
    AOS.init();
 
    $(".lazy").Lazy();

    // const $main_navigation = $('.navbar');
    //
    // function scrollEvents () {
    //   if ($(window).scrollTop() > 32) {
    //     $main_navigation.addClass('active');
    //   } else {
    //     $main_navigation.removeClass('active');
    //   }
    // }
    //
    // window.addEventListener('scroll', throttle(scrollEvents, 32));
});

$(function () {
    if ($("#form_survey").length) {
        $(".tipso.newcomer").tipso({
            content:
                "This category cannot be won by an artist who has won it previously.",
        });

        $(".tipso.vocalist").tipso({
            content:
                "A vocalist is a performer who sings - votes for performers who do not sing will be void. <br><br>DRS has elected not to be included in the Best Vocalist or Best MC categories, so votes for him in these categories will be void.",
        });

        $(".tipso.mc").tipso({
            content:
                "DRS has elected not to be included in the Best Vocalist or Best MC categories, so votes for him in these categories will be void.",
        });

        $(".tipso.club_night").tipso({
            content:
                "Any events held anywhere in the world after October 23rd, 2020 qualify in this section - this includes socially-distanced events.",
        }); 

        $(".tipso.new-label").tipso({
            content:
                "Labels launched since December 2018 - please note previous year’s winners cannot be nominated again.",
        });

        $(".tipso.artwork").tipso({
            content: "Please list your choice according to the release title.",
        });

        $(".tipso.livestream").tipso({
            content:
                "Please list the artist and which set you are voting for - individual artist submissions will only be accepted if they had a regular series. ",
        });

        $(".tipso.messenger").tipso({
            content:
                "Connect with us on Messenger to stay up to date with all things Drum&BassArena.",
        });
    }
});

$(function () {
    let $allVideos = $(
            "iframe[src^='http://www.youtube'], iframe[src^='https://www.youtube'], iframe[src^='https://youtube'], iframe[src^='http://youtube']"
        ),
        $fluidEl = $(".post-content");

    $allVideos.each(function () {
        $(this)
            .data("aspectRatio", this.height / this.width)
            .removeAttr("height")
            .removeAttr("width");
    });
    $(window)
        .resize(function () {
            let newWidth = $fluidEl.width();
            $allVideos.each(function () {
                let $el = $(this);
                $el.width(newWidth).height(newWidth * $el.data("aspectRatio"));
            });
        })
        .resize();
});

$(document).ready(function () {
    //jQuery time
    var currentPage, nextPage, previousPage; //pages
    var left, opacity, scale; //fieldset properties which we will animate
    var animating; //flag to prevent quick multi-click glitches

    $(".next").on("click", function (e) {
        e.preventDefault();
        const $logo = $("#splash-logo");

        if (animating) return false;
        animating = true;

        currentPage = $(this).parents(".paged-form__page");
        nextPage = $(this).parents(".paged-form__page").next();

        //show the next fieldset
        nextPage.show();
        if ($logo.length) {
            $logo.addClass("shrink");
        }

        //hide the current fieldset with style
        currentPage.animate(
            { opacity: 0 },
            {
                step: function (now, mx) {
                    //as the opacity of currentPage reduces to 0 - stored in "now"
                    //1. scale currentPage down to 80%
                    scale = 1 - (1 - now) * 0.2;
                    //2. bring nextPage from the right(50%)
                    left = now * 50 + "%";
                    //3. increase opacity of nextPage to 1 as it moves in
                    opacity = 1 - now;
                    currentPage.css({
                        transform: "scale(" + scale + ")",
                        position: "absolute",
                    });
                    nextPage.css({ left: left, opacity: opacity });
                },
                duration: 500,
                complete: function () {
                    currentPage.hide();
                    animating = false;
                },
                //this comes from the custom easing plugin
                // easing: 'easeInOutBack'
            }
        );
    });

    // $(".previous").click(function(){
    //   if(animating) return false;
    //   animating = true;
    //
    //   currentPage = $(this).parent();
    //   previousPage = $(this).parent().prev();
    //
    //   //de-activate current step on progressbar
    //   $("#progressbar li").eq($("fieldset").index(currentPage)).removeClass("active");
    //
    //   //show the previous fieldset
    //   previousPage.show();
    //   //hide the current fieldset with style
    //   currentPage.animate({opacity: 0}, {
    //     step: function(now, mx) {
    //       //as the opacity of currentPage reduces to 0 - stored in "now"
    //       //1. scale previousPage from 80% to 100%
    //       scale = 0.8 + (1 - now) * 0.2;
    //       //2. take currentPage to the right(50%) - from 0%
    //       left = ((1-now) * 50)+"%";
    //       //3. increase opacity of previousPage to 1 as it moves in
    //       opacity = 1 - now;
    //       currentPage.css({'left': left});
    //       previousPage.css({'transform': 'scale('+scale+')', 'opacity': opacity});
    //     },
    //     duration: 800,
    //     complete: function(){
    //       currentPage.hide();
    //       animating = false;
    //     },
    //     //this comes from the custom easing plugin
    //     easing: 'easeInOutBack'
    //   });
    // });

    // $(".submit").click(function(){
    //   return false;
    // })

    $("#button-subscribe-submit").on("click", function (event) {
        event.preventDefault();
        $("#mailchimp-signup .mailchimp-submit").trigger("click");
    });

    const $html = $("html");

    $(".scroll").on("click", function () {
        $html.animate(
            {
                scrollTop: $("section.history").offset().top - 75,
            },
            600
        );
        return false;
    });

    $("#button-scroll-winners").on("click", function () {
        $html.animate(
            {
                scrollTop: $("section.winners-after-stream").offset().top - 75,
            },
            600
        );
        return false;
    });
});

let AjaxAC = {};

AjaxAC.signUp = {
    init: function () {
        this.submitForm();
    },

    loading: function () {
        // $("#ac-loading").show()
    },

    formResult: function (data) {
        const $acResult = $("#ac-result");
        $acResult.show().html("");
        $acResult.html(data);
        $("#ac-signup .input").val("");
        // setTimeout(function () {
        //   $acResult.fadeOut()
        // }, 7000);

        // show shares on success
        // if ($("#signup_result .success").length) {
        //     $(".social.social-div").addClass("signup_success");
        // }
    },

    submitForm: function () {
        $("#ac-signup").submit(function () {
            let ac_newsletter = 0;
            if ($("#ac-newsletter").is(":checked")) {
                ac_newsletter = 1;
            }

            AjaxAC.signUp.loading();

            const action = $(this).attr("action");

            $.ajax({
                url: action,
                type: "POST",
                data: {
                    email: $("#ac-email").val(),
                    fname: $("#ac-fname").val(),
                    newsletter: ac_newsletter,
                },
                success: function (data) {
                    AjaxAC.signUp.formResult(data);
                    // FB Checkbox submit
                    window.confirmOptIn();
                },
                error: function (data) {
                    AjaxAC.signUp.formResult(data);
                },
            });
            return false;
        });
    },
};

$(function () {
    AjaxAC.signUp.init();
});
